import clubEvents from "../data/club-events.json";
import DB from "../data/Events.json";

export const getEventData = (eventCode) => {
  const event = DB.filter((item) => item.eventCode === eventCode);

  return {
    data: {
      success: true,
      event: event[0],
    },
  };
};

export const getClubEvents = (clubName) => {
  const events = clubEvents.filter(
    (item) => item.club === clubName.toLowerCase()
  );
  return {
    data: {
      success: true,
      events,
    },
  };
};
